import { Injectable } from '@angular/core';
import { UIThemeType } from '@cl/shared/models';

@Injectable({ providedIn: 'root' })
export class ThemeService {
    private currentTheme: string | null = null;

    private loadCss(href: string, id: string) {
        return new Promise<Event>((resolve, reject) => {
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href; // IMPORTANT: absolute path so deep routes work
            link.id = id;
            link.onload = resolve;
            link.onerror = reject;
            document.head.appendChild(link);
        });
    }

    private themeMap: Record<UIThemeType, string> = {
        [UIThemeType.Default]: 'default',
        [UIThemeType.DefaultCompact]: 'default-compact',
        [UIThemeType.Dark]: 'dark',
        [UIThemeType.DarkCompact]: 'dark-compact',
        [UIThemeType.Aliyun]: 'aliyun',
        [UIThemeType.AliyunCompact]: 'aliyun-compact',
        [UIThemeType.Colorful]: 'colorful',
        [UIThemeType.ColorfulCompact]: 'colorful-compact',
        [UIThemeType.Mono]: 'mono',
        [UIThemeType.MonoCompact]: 'mono-compact',
        [UIThemeType.Teams]: 'teams',
        [UIThemeType.TeamsCompact]: 'teams-compact',
        [UIThemeType.TeamsAccented]: 'teams-accented',
        [UIThemeType.TeamsAccentedCompact]: 'teams-accented-compact',
    };

    async switchTheme(uiTheme: UIThemeType, firstLoad = false): Promise<void> {
        let next: string = this.themeMap[uiTheme];

        if (!next || (next === this.currentTheme && !firstLoad)) {
            return;
        }

        localStorage.setItem('uiTheme', uiTheme.toString());
        document.documentElement.classList.add(next);

        await this.loadCss(`/${next}.css`, next);

        // only remove the old theme AFTER the new one is loaded, and ONLY if there was one
        if (this.currentTheme && this.currentTheme !== next) {
            document.documentElement.classList.remove(this.currentTheme);
            const old = document.getElementById(this.currentTheme);
            if (old) old.remove();
        }

        this.currentTheme = next;
    }
}
